module.exports = __webpack_public_path__ + "static/img/flat-cut-anodized-aluminum-letters.fc72d9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/specialty-items/flat-cut-anodized-aluminum-letters.jpg
// module id = 682
// module chunks = 0